import { CustomButton } from '@Modules/core/components';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export interface IBankComissionDatatable {
  codeTransaction: string;
  dc: string;
  taux: string;
  fixe: string;
  minimum: string;
  maximum: string;
}

const columns = (handleEdit: any) => [
  {
    id: 'codeTransaction',
    header: 'Code Transaction',
    accessorKey: 'codeTransaction',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'dc',
    header: 'D/C',
    accessorKey: 'dc',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'taux',
    header: 'Taux',
    accessorKey: 'fixe',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'minimum',
    header: 'Minimum',
    accessorKey: 'minimum',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'maximum',
    header: 'Maximum',
    accessorKey: 'maximum',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'action',
    header: 'Action',
    accessorKey: 'action',
    cell: (ctx: any) => {
      const row = ctx.row.origial;
      return (
        <CC.Box>
          <CustomButton onClick={() => handleEdit(row)}>Editer</CustomButton>

          {/* <CustomButton onClick={() => handleDel(row)} variant="ghost" ml="2">
            Supp
          </CustomButton> */}
        </CC.Box>
      );
    },
  },
];

export const BankComissionDatatableMeta = {
  columns,
};
